import * as api from '../../api';
import { pagingDataUtilities } from '../../common';
import { participantTypeHelpers } from '../../participant-types';

export const fetchListActions = api.fetchActions('registered-participants', 'fetch-registered-participants');
export const disableBatchActions = api.fetchActions('registered-participants', 'disable-registered-participants');
export const enableBatchActions = api.fetchActions('registered-participants', 'enable-registered-participants');
export const pagingActions = pagingDataUtilities.pagingActions('registered-participants', 'paging');

export const actionTypes = {
  ...fetchListActions.actionTypes,
  ...disableBatchActions.actionTypes,
  ...enableBatchActions.actionTypes,
  ...pagingActions.actionTypes,
  SELECT_PARTICIPANT : 'registered-participants.select-participant',
  SELECT_ALL_PARTICIPANTS : 'registered-participants.select-all-participant',
  SET_SEARCH_TEXT : 'registered-participants.set-search-text',
  START_SEARCH : 'registered-participants.start-search',
  SET_SELECTED_SAVE_OPTION : 'registered-participants.set-selected-save-option'
}

export function fetchList() {
  return (dispatch, getState) => {
    const state = getState();
    const { registeredParticipants } = state;
    const { pagingData, searchQuery } = registeredParticipants;
    const { currentPage, itemsPerPage, sortBy, sortAsc } = pagingData || {};
    const { sites } = state;
    const params = {
      participantTypeId: participantTypeHelpers.getParticipantTypeId(),
      registered : true,
      page: currentPage,
      perPage: itemsPerPage,
      sortBy,
      sortAsc,
      search: searchQuery,
      siteId: sites && sites.selectedSiteId,
      programId: sites && sites.selectedProgramId
    };
    return dispatch(api.shouldExecute(['registeredParticipants', 'listState'], api.getThunk(`/participants`, params, fetchListActions)));
  }
}

// TODO: change the following functions to work as intended as a part of PP-106 and PP-107(this is a temporary way to update existing participant data to work with api keys)
export function disableParticipants() {
  return (dispatch, getState) => {
    const state = getState();
    const { registeredParticipants } = state;
    const { enabledParticipants } = registeredParticipants;
    const params = {
      participantTypeId: participantTypeHelpers.getParticipantTypeId(),
      participantIds : enabledParticipants.toJS(),
    };
    return dispatch(api.postThunk(`/participants/batch/disable`, params, disableBatchActions));
  }
}

export function enableParticipants() {
  return (dispatch, getState) => {
    const state = getState();
    const { registeredParticipants } = state;
    const { disabledParticipants } = registeredParticipants;
    const params = {
      participantTypeId: participantTypeHelpers.getParticipantTypeId(),
      participantIds : disabledParticipants.toJS(),
    };
    return dispatch(api.postThunk(`/participants/batch/enable`, params, enableBatchActions));
  }
}

export const changePageNumber = (page) => pagingDataUtilities.changePage(page, pagingActions);
export const changeSort = (newSort) => pagingDataUtilities.changeSort(newSort, pagingActions, ['registeredParticipants', 'pagingData']);
export const changeResultsPerPage = (perPage) => pagingDataUtilities.changePerPage(perPage, pagingActions, ['registeredParticipants', 'pagingData']);

export function selectParticipant(id, status) {
  return {
    type : actionTypes.SELECT_PARTICIPANT,
    id,
    status
  }
}


export function selectAllParticipants() {
  return {
    type : actionTypes.SELECT_ALL_PARTICIPANTS
  }
}

export function setSearchText(text) {
  return {
    type : actionTypes.SET_SEARCH_TEXT,
    text
  }
}

export function startSearch() {
  return {
    type : actionTypes.START_SEARCH
  }
}

/**
 * This action method is called whenever the admin selects a radio button option to search by site/program or by lname/email.
 * It updates the store with the radio button value and this value is used in the search component to display the sites/programs
 * dropdownlist or display the text area
 * @param {guid} value : value of the radiobutton element
 */
export function setSelectedSaveOption(value) {
  return {
    type: actionTypes.SET_SELECTED_SAVE_OPTION,
    value
  }
}
